module.exports = __webpack_public_path__ + "static/img/bksq (2).a105c596.png";